module.exports = __webpack_public_path__ + "static/assets/5888c4ba6b8a0767f8be5bbc81994397.mp3";